var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIcInfo(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_3092_38270)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M8 1C11.866 1 15 4.134 15 8C15 11.866 11.866 15 8 15C4.134 15 1 11.866 1 8C1 4.134 4.134 1 8 1ZM8 6.66699C7.63211 6.66699 7.33318 6.96449 7.33301 7.33301V11.333C7.33301 11.7017 7.632 12 8 12C8.368 12 8.66699 11.7017 8.66699 11.333V7.33301C8.66682 6.96449 8.36789 6.66699 8 6.66699ZM7.70605 4.01465C7.51739 4.03398 7.3673 4.18407 7.34863 4.37207C7.328 4.56862 7.32798 4.76537 7.34863 4.96191C7.36736 5.14984 7.51744 5.29903 7.70605 5.31836C7.9019 5.33831 8.09841 5.33834 8.29492 5.31836C8.48285 5.29903 8.63195 5.14982 8.65137 4.96191C8.67136 4.76535 8.67134 4.56863 8.65137 4.37207C8.63203 4.18407 8.48292 4.03398 8.29492 4.01465C8.09844 3.99467 7.90187 3.9947 7.70605 4.01465Z",
    fill: "#00880D"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_3092_38270"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 16,
    height: 16,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcInfo);
export default __webpack_public_path__ + "static/media/ic_info.11e8489d72cd7346d0d5fb7b9fc038df.svg";
export { ForwardRef as ReactComponent };